var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'task-item-container',
    ("level-" + _vm.level),
    { 'has-children': _vm.hasChildren, last: _vm.last } ]},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"content",style:({
      marginLeft: ((_vm.level * 20) + "px"),
    })},[_vm._t("content")],2),_vm._v(" "),_vm._t("actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }